<template>
  <div class="middle_slider">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in slider_img" :key="item.id">
          <a :href="item.url" target="_blank">
            <picture>
              <source media="(max-width: 768px)" :srcset="item.image2_url" :alt="item.title" />
              <img :src='item.image_url' :alt="item.title" />
            </picture>
          </a>
        </div>
        <div v-show="loading == 1" style="margin:40px auto;font-size:21px;text-align: center;">
          <img src="../../assets/loading.gif">
        </div>
      </div>
      <!-- <div class="swiper-pagination"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
  name: 'middleSlider',
  props: {},
  data() {
    return {
      slider_img: [],
      loading: 1,
    }
  },
  computed: {
  },
  created() {
    var slider_img = this
    var slider_api = process.env.VUE_APP_API + 'tlweb/banner?position=2'
    this.axios.get(slider_api)
      .then(function (response) {
        slider_img.slider_img = response.data.data.data
        new Swiper('.middle_slider .swiper-container', {
          spaceBetween: 30,
          centeredSlides: true,
          autoplayDisableOnInteraction: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          observer: true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents: true,//修改swiper的父元素时，自动初始化swiper
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true,
          // },
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
        })
      })
      .catch(function (error) {
        console.log(error);
      });
    this.loading = 0;
  },
}
</script>

<style>
.middle_slider .swiper-container {
  max-width: 1105px;
  max-height: 640px;
}

.middle_slider img {
  width: 100%;
  height: 100%;
}

@media (min-width: 769px) {
  .middle_slider .mobile_slider {
    display: none;
  }
}

@media (max-width: 768px) {
  .middle_slider .pc_slider {
    display: none;
  }
}
</style>
